import React from 'react'
import {useIntl} from 'react-intl'
import {InputSearch, TableHeader} from '../../../../../../_gori/partials/widgets'

const ManagersFilter: React.FC = () => {
  const intl = useIntl()

  return (
    <TableHeader className='min-h-1px my-5 mb-8 d-flex flex-column'>
      <div className='d-flex flex-fill flex-column py-5'>
        <div className='d-flex flex-wrap align-items-start gap-3 col-12'>
          <div className='d-flex flex-wrap align-items-start gap-3 filter-toolbar-44 col-12'>
            <div className='d-flex position-relative col-12'>
              <InputSearch placeholder={intl.formatMessage({id: 'SEARCH_MANAGER'})} />
            </div>
          </div>
        </div>
      </div>
    </TableHeader>
  )
}

export {ManagersFilter}
